var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.4 10.4a6.4 6.4 0 1 1-12.8 0a6.4 6.4 0 0 1 12.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152E51",
    d: "M9.121 20a3.521 3.521 0 1 0 0-7.042a3.521 3.521 0 0 0 0 7.042"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152E51",
    d: "M8.733 4.895V13.8h.785V4.5a6 6 0 0 0-.785.396"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendle);
export default __webpack_public_path__ + "static/media/pendle.61fd997cd5b3e5abb8ece56f3616acfc.svg";
export { ForwardRef as ReactComponent };